// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/theme/topbar/module';
import './modules/theme/megamenu/module';
import './modules/theme/account-dropdown/module';
import './modules/theme/hero/module';
import './modules/theme/category-boxes/module';
import './modules/theme/about-us/module';
import './modules/theme/gallery-case-studies/module';
import './modules/theme/brands/module';

// layouts

// leave me last
import './js/base/base-end';
